import React from "react";
import { FiMenu } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { NavItemType } from "../../../navigation";
import { Tooltip } from "@mui/material";
import { BiChevronRight } from "react-icons/bi";
import { setExpandedIndex } from "src/redux/slices/SideNavLayoutSlice";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/redux/store";

type Props = {
  toggleCollapse: () => void;
  isCollapsed: boolean;
  navigation: NavItemType[];
  isPathEqualtoNavItem?: (navItem: any) => boolean;
};

const VerticalNavBar = ({
  toggleCollapse,
  isCollapsed,
  navigation,
  isPathEqualtoNavItem = () => false,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sideNavLayoutState: any = useSelector(
    (state: RootState) => state.sideNavLayout
  );

  const { expandedIndex } = sideNavLayoutState;
  return (
    <div
      className={`h-full  overflow-auto bg-primary-dark transition-all duration-500 border-r border-slate-300 md:static absolute z-[1]  ${
        isCollapsed
          ? "md:min-w-[0px] md:w-[0px] min-w-0 w-0"
          : "min-w-[230px] w-[230px]"
      }`}
    >
      {/* Logo & Menu Icon */}
      <div
        className={`flex px-4 items-center justify-between sticky top-0 py-3 h-[55px]`}
      >
        {/* Logo */}
        <div
          className={`font-semibold text-xl text-white ${
            isCollapsed && "md:hidden"
          }`}
        >
          Pro Library
        </div>

        {/* Menu Icon */}
        <Tooltip title="Alt + T">
          <button
            type="button"
            onClick={toggleCollapse}
            className="text-xl text-white"
          >
            <FiMenu className="hidden md:block" />
            <MdCancel className="block md:hidden text-xl" />
          </button>
        </Tooltip>
      </div>

      {/* Navigations */}
      <div className="  flex flex-col ">
        {navigation?.map((navItem: any, navIndex: number) => {
          return (
            <React.Fragment key={navIndex}>
              <div
                key={navIndex}
                onClick={() =>
                  navItem.path && !navItem.children
                    ? navigate({
                        pathname: navItem.path,
                      })
                    : dispatch(
                        setExpandedIndex(
                          expandedIndex === navIndex ? -1 : navIndex
                        )
                      )
                }
                className={`
                py-3 
                px-4
                cursor-pointer 
                ${!isPathEqualtoNavItem(navItem) && "hover:bg-primary-light "} 
                transition-all
                duration-300
                text-white
                2xl:text-base md:text-body-1
                font-normal
                ${
                  isPathEqualtoNavItem(navItem)
                    ? "bg-primary-main font-semibold"
                    : ""
                } 
                `}
              >
                <div className="flex justify-between items-center">
                  <div className="flex gap-3 items-center">
                    {" "}
                    <navItem.icon />{" "}
                    {!isCollapsed && <div className=""> {navItem.label} </div>}
                  </div>
                  {navItem.children && !isCollapsed && (
                    <div>
                      <BiChevronRight
                        className={`text-2xl text-white  transition-all mt-  ${
                          expandedIndex === navIndex && "rotate-90"
                        }`}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* Children */}
              {expandedIndex === navIndex && !isCollapsed && (
                <div className="flex flex-col gap-1 px-4">
                  {navItem.children?.map(
                    (navChild: any, navChildIndex: number) => (
                      <div
                        key={navChildIndex}
                        onClick={(e) => {
                          e.stopPropagation();
                          navChild.path &&
                            navigate({
                              pathname: navChild.path,
                              // search: `?${createSearchParams(
                              //   navChild.searchParams
                              // )}`,
                            });
                        }}
                        id={
                          isPathEqualtoNavItem(navChild) ? "scroll-to-view" : ""
                        }
                        className={`
              cursor-pointer  
              transition-all
              duration-500
              text-[14px]
              ${isCollapsed && "justify-center"}
              ${
                isPathEqualtoNavItem(navChild)
                  ? "text-white font-semibold border-l-[2px] border-l-white"
                  : "text-slate-300"
              } 
              `}
                      >
                        {!isCollapsed && (
                          <div className="flex gap-4 items-center my-1 pl-3">
                            <navChild.icon />
                            <div
                              className={`${
                                isPathEqualtoNavItem(navChild)
                                  ? "text-white font-semibold border-l-[3px] border-l-primary-main"
                                  : "text-slate-400"
                              }`}
                            >
                              {" "}
                              {navChild.label}{" "}
                            </div>
                          </div>
                        )}

                        {/* {navChild.badge !== undefined
                          ? !isCollapsed &&
                            (isFetching || isLoading ? (
                              <div className="bg-slate-300 rounded-full h-5 w-5 animate-pulse"></div>
                            ) : (
                              <Badge value={navChild.badge} />
                            ))
                          : null} */}
                      </div>
                    )
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default VerticalNavBar;
